import type { Parcel } from '../types';
import { getOperatorScopedStorageKey } from './operatorSession';

export interface PackagePreset { id: string; name: string; parcel: Parcel }
export const DEFAULT_PACKAGE_PRESETS: PackagePreset[] = [
  { id: 'small', name: 'Small parcel', parcel: { length: 10, width: 8, height: 4, weight: 16 } },
  { id: 'medium', name: 'Medium parcel', parcel: { length: 12, width: 10, height: 6, weight: 32 } },
  { id: 'envelope', name: 'FedEx Envelope', parcel: { predefined_package: 'FedExEnvelope' } },
];
const KEY = 'easypost_package_presets_v1';
export function isUsablePackage(parcel: Parcel): boolean {
  return Number.isFinite(parcel.weight) && Number(parcel.weight) > 0
    && (Boolean(parcel.predefined_package) || [parcel.length, parcel.width, parcel.height].every(value => Number.isFinite(value) && Number(value) > 0));
}
export function loadPackagePresets(): PackagePreset[] {
  try {
    const key = getOperatorScopedStorageKey(KEY);
    if (!key) return [];
    const saved: unknown = JSON.parse(localStorage.getItem(key) ?? '[]');
    if (!Array.isArray(saved)) return [];
    return saved.filter((item): item is PackagePreset => item && typeof item.id === 'string' && typeof item.name === 'string' && item.name.trim().length > 0 && item.name.length <= 60 && item.parcel && isUsablePackage(item.parcel)).slice(0, 20);
  } catch { return []; }
}
export function savePackagePreset(name: string, parcel: Parcel): PackagePreset | null {
  const trimmed = name.trim();
  if (!trimmed || trimmed.length > 60 || !isUsablePackage(parcel)) return null;
  try {
    const key = getOperatorScopedStorageKey(KEY);
    if (!key) return null;
    const saved = loadPackagePresets();
    const previous = saved.find(item => item.name.toLocaleLowerCase() === trimmed.toLocaleLowerCase());
    const preset = { id: previous?.id ?? `saved-${crypto.randomUUID()}`, name: trimmed, parcel: { ...parcel } };
    localStorage.setItem(key, JSON.stringify([preset, ...saved.filter(item => item.id !== preset.id)].slice(0, 20)));
    return preset;
  } catch { return null; }
}
